<!-- 综合屏 -->
<template>
  <div class="audit" id="indexMain">
    <div id="container"></div>
    <div class="title-left-dropdown"></div>
    <div class="titles" style="font-size: 28px; font-weight: bold; color: #ffffff">
      <span style="letter-spacing: 4.22px">益通健心心理健康管理平台</span>
      <div class="title-date">{{ dateYear }} {{ dateDay }} {{ dateWeek }}</div>
      <div class="title-dropdown">
        <!-- <span
          style="
            width: 75px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
            color: #fff;
            font-size: 14px;
          "
          >{{ userName }}</span
        > -->
      </div>
    </div>
    <!-- 以上是头部布局 -->
    <div class="lefts" >
      <div class="side-item" style="flex: none; height: 180px">
        <div class="side-item-title">
          <span style="cursor: pointer">测评人数</span>
        </div>
        <div class="side-item-content" style="text-align: center; line-height: 152px">
          <count-to
            class="number-box"
            :start-val="0"
            :end-val="sumValues.value2"
            :duration="2000"
          ></count-to>
        </div>
      </div>
      <div class="side-item">
        <div class="side-item-title">
          <span style="cursor: pointer">年龄分布</span>
        </div>
        <div class="side-item-content">
          <div id="age-chart" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="side-item">
        <div class="side-item-title">
          <span style="cursor: pointer">性别分布</span>
        </div>
        <div class="side-item-content">
          <div id="gender-chart" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </div>
    <div class="rights"  >
      <div class="side-item" style="flex: none; height: 180px">
        <div class="side-item-title">
          <span style="cursor: pointer">测评次数</span>
        </div>
        <div class="side-item-content" style="text-align: center; line-height: 152px">
          <count-to
            class="number-box"
            :start-val="0"
            :end-val="sumValues.value1"
            :duration="2000"
          ></count-to>
        </div>
      </div>
      <div class="side-item" style="flex: none; height: 37%">
        <div class="side-item-title">
          <span style="cursor: pointer">测查前10量表</span>
        </div>
        <div class="side-item-content">
          <ul class="list-title">
            <li>
              <p class="table-no" title="序号">排名</p>
              <p class="table-name" title="企业名称">量表名称</p>
              <p class="table-count" title="次数">次数</p>
            </li>
          </ul>
          <vue-seamless-scroll
            :data="stsData.topTen"
            class="seamless-warp"
            :class-option="optionSetting"
          >
            <ul class="scoll-main">
              <li class="main-list" v-for="(item, index) in stsData.topTen" :key="index">
                <p class="table-no" :title="index">
                  {{ index + 1 }}
                </p>
                <p class="table-name" :title="item.scale_name">
                  {{ item.scale_name }}
                </p>
                <p class="table-count" :title="item.count">
                  {{ item.count }}
                </p>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
      <div class="side-item" style="flex: none; height: 37%">
        <div class="side-item-title">
          <span style="cursor: pointer">重测前10量表</span>
        </div>
        <div class="side-item-content">
          <ul class="list-title">
            <li>
              <p class="table-no" title="序号">排名</p>
              <p class="table-name" title="企业名称">量表名称</p>
              <p class="table-count" title="次数">次数</p>
            </li>
          </ul>
          <vue-seamless-scroll
            :data="stsData.topTen"
            class="seamless-warp"
            :class-option="optionSetting"
          >
            <ul class="scoll-main">
              <li
                class="main-list"
                v-for="(item, index) in stsData.resurveyTopTen"
                :key="index"
              >
                <p class="table-no" :title="index">
                  {{ index + 1 }}
                </p>
                <p class="table-name" :title="item.scale_name">
                  {{ item.scale_name }}
                </p>
                <p class="table-count" :title="item.resurvey_count">
                  {{ item.resurvey_count }}
                </p>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <!-- 新增部分：测评次数排名前五的公司 -->
    <div class="bottom-center">
      <ul class="bottom-center-list">
        <li v-for="(item, index) in topFiveCompanies" :key="index" class="company-item" @click="showPopup(item)">
          <span class="company-rank"> 
            <img :src="require(`./assets/${index+1}.svg`)"  alt=""> 
          </span>
          <span class="company-name" :title="item.name">{{ item.name }}</span>
          <span class="company-count">{{ item.value1 }}</span>
          <img class="bottom-center-img" src="./assets/base.webp" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import screenfull from "screenfull";
import vueSeamlessScroll from "vue-seamless-scroll";
import * as echarts from "echarts";
import hospitalIcon from "@/assets/markers/hospital.svg";
import countTo from "vue-count-to";

import 'ol/ol.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
import { Style, Fill, Stroke, Text, Icon } from 'ol/style';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj'; 
export default {
  name: "",
  //import引入的组件需要注入到对象中才能使用
  components: {
    countTo,
    vueSeamlessScroll,
  },
  data() {
    //这里存放数据
    return {
      warningsData: [],
      statisticsData: [],
      isShowInfo: false, 
      markers: [],
      map: null,
      sumValues: {
        value1: 0,
        value2: 0,
      },
       points: [
    {
        "name": "北京回龙观医院(内网)",
        "lng": 116.336438,
        "lat": 40.072505,
        "value1": 481409,
        "value2": 93217
    },
    {
        "name": "北京积水潭医院",
        "lng": 116.381893,
        "lat": 39.950309,
        "value1": 94064,
        "value2": 18432
    },
    {
        "name": "武汉大学中南医院",
        "lng": 114.359743,
        "lat": 30.560207,
        "value1": 82202,
        "value2": 27011
    },
    {
        "name": "南京脑科医院",
        "lng": 118.774905,
        "lat": 32.056219,
        "value1": 23904,
        "value2": 5683
    },
    {
        "name": "武汉市武东医院",
        "lng": 114.469206,
        "lat": 30.58081,
        "value1": 14575,
        "value2": 3804
    },
    {
        "name": "云南省第一人民医院新昆华医院",
        "lng": 102.580551,
        "lat": 24.928435,
        "value1": 6315,
        "value2": 1254
    },
    {
        "name": "北京回龙观医院",
        "lng": 116.336438,
        "lat": 40.072505,
        "value1": 194675,
        "value2": 18906
    },
    {
        "name": "淄博市精神卫生中心",
        "lng": 117.990367,
        "lat": 36.640381,
        "value1": 8127,
        "value2": 4712
    },
    {
        "name": "深圳市康宁医院",
        "lng": 114.13742,
        "lat": 22.570643,
        "value1": 26951,
        "value2": 5378
    },
    {
        "name": "哈尔滨市第一专科医院",
        "lng": 126.706521,
        "lat": 45.777983,
        "value1": 1760,
        "value2": 392
    },
    {
        "name": "荆门市中心医院",
        "lng": 112.204554,
        "lat": 31.035253,
        "value1": 8813,
        "value2": 3281
    },
    {
        "name": "新疆精神卫生中心",
        "lng": 87.648355,
        "lat": 43.804705,
        "value1": 2103,
        "value2": 276
    },
    {
        "name": "贵州省第二人民医院",
        "lng": 106.735575,
        "lat": 26.61372,
        "value1": 504,
        "value2": 211
    },
    {
        "name": "河南南阳第四人民医院",
        "lng": 112.530062,
        "lat": 33.032462,
        "value1": 1080,
        "value2": 201
    },
    {
        "name": "中国医科大学附属第一医院",
        "lng": 123.417934,
        "lat": 41.800873,
        "value1": 764,
        "value2": 697
    },
    {
        "name": "内蒙古精神卫生中心",
        "lng": 111.703391,
        "lat": 40.826927,
        "value1": 1286,
        "value2": 1056
    },
    {
        "name": "北京大学临床教学医院",
        "lng": 116.366607,
        "lat": 39.988558,
        "value1": 660,
        "value2": 617
    },
    {
        "name": "河北北方学院附属第二医院",
        "lng": 115.070192,
        "lat": 40.62233,
        "value1": 53,
        "value2": 21
    },
    {
        "name": "赣州市第三人民医院",
        "lng": 114.958909,
        "lat": 25.838673,
        "value1": 290249,
        "value2": 24607
    },
    {
        "name": "北京未来儿童医院",
        "lng": 116.207313,
        "lat": 39.926727,
        "value1": 500,
        "value2": 68
    },
    {
        "name": "山西省社会福利精神康宁医院",
        "lng": 112.469538,
        "lat": 37.893038,
        "value1": 370,
        "value2": 48
    },
    {
        "name": "镇雄县人民医院",
        "lng": 104.884169,
        "lat": 27.411919,
        "value1": 41,
        "value2": 13
    },
    {
        "name": "临沧市第三人民医院",
        "lng": 100.10589,
        "lat": 23.902007,
        "value1": 28,
        "value2": 2
    },
    {
        "name": "山西大同第六人民医院",
        "lng": 113.226491,
        "lat": 40.035419,
        "value1": 235,
        "value2": 45
    },
    {
        "name": "中科软科技",
        "lng": 116.331161,
        "lat": 39.987188,
        "value1": 23,
        "value2": 3
    },
    {
        "name": "回龙观心理测量中心",
        "lng": 116.334565,
        "lat": 40.066494,
        "value1": 628,
        "value2": 45
    },
    {
        "name": "北京安定医院",
        "lng": 116.38321,
        "lat": 39.95878,
        "value1": 620,
        "value2": 568
    },
    {
        "name": "北京地坛医院",
        "lng": 116.532379,
        "lat": 40.029412,
        "value1": 13,
        "value2": 5
    },
    {
        "name": "东城区精保所",
        "lng": 116.44712,
        "lat": 39.948859,
        "value1": 5474,
        "value2": 2550
    },
    {
        "name": "南宁第五人民医院",
        "lng": 108.34385,
        "lat": 22.864545,
        "value1": 237,
        "value2": 41
    },
    {
        "name": "安宁市第一人民医院",
        "lng": 102.48276,
        "lat": 24.9258,
        "value1": 1334,
        "value2": 558
    },
    {
        "name": "山东省精神卫生中心",
        "lng": 117.069687,
        "lat": 36.660513,
        "value1": 554,
        "value2": 154
    },
    {
        "name": "宁波市康宁医院",
        "lng": 121.628251,
        "lat": 29.940818,
        "value1": 111,
        "value2": 58
    },
    {
        "name": "西安市精神卫生中心",
        "lng": 109.009107,
        "lat": 34.179602,
        "value1": 125,
        "value2": 49
    },
    {
        "name": "天门市第一人民医院",
        "lng": 113.181396,
        "lat": 30.65536,
        "value1": 167,
        "value2": 49
    },
    {
        "name": "锡盟安神医院",
        "lng": 116.14536,
        "lat": 43.954147,
        "value1": 31,
        "value2": 26
    },
    {
        "name": "山东临沂精神卫生中心",
        "lng": 118.56899,
        "lat": 34.899822,
        "value1": 100,
        "value2": 22
    },
    {
        "name": "河北医科大学第一附属医院",
        "lng": 114.559267,
        "lat": 38.022621,
        "value1": 89,
        "value2": 13
    },
    {
        "name": "随州中心医院",
        "lng": 113.382362,
        "lat": 31.714625,
        "value1": 36,
        "value2": 9
    },
    {
        "name": "中国科技大学第一附属医院省立医院",
        "lng": 117.255678,
        "lat": 31.821516,
        "value1": 13,
        "value2": 6
    },
    {
        "name": "山西中医药大学附属医院",
        "lng": 112.53599,
        "lat": 37.849857,
        "value1": 24,
        "value2": 5
    },
    {
        "name": "北京大学第六医院",
        "lng": 116.364216,
        "lat": 39.988056,
        "value1": 7,
        "value2": 4
    },
    {
        "name": "武汉市精神卫生中心",
        "lng": 114.280635,
        "lat": 30.580352,
        "value1": 4,
        "value2": 2
    },
    {
        "name": "辽中精神病医院",
        "lng": 122.701767,
        "lat": 41.425108,
        "value1": 4,
        "value2": 2
    },
    {
        "name": "朝阳区第三医院",
        "lng": 116.609789,
        "lat": 39.893503,
        "value1": 6,
        "value2": 2
    },
    {
        "name": "无锡市精神卫生中心",
        "lng": 120.239059,
        "lat": 31.598138,
        "value1": 17,
        "value2": 1
    },
    {
        "name": "清华长庚医院",
        "lng": 116.421334,
        "lat": 40.078728,
        "value1": 7,
        "value2": 1
    },
    {
        "name": "贵州省第二人民医院",
        "lng": 106.735575,
        "lat": 26.61372,
        "value1": 504,
        "value2": 211
    },
    {
        "name": "北京大学医院",
        "lng": 116.320654,
        "lat": 40.002706,
        "value1": 1,
        "value2": 1
    },
    {
        "name": "安徽省精神卫生中心",
        "lng": 117.269817,
        "lat": 31.849957,
        "value1": 1,
        "value2": 1
    }
],
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timer: null,
      stsData: {},
      date: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    // 设置底部滚动
    optionSetting() {
      return {
        step: 0.1, // 数值越大速度滚动越快
        // limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 30, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 50, // 单步运动停止的时间(默认值1000ms)
      };
    },
    topFiveCompanies() {
      if (this.stsData.org) {
        return this.stsData.org.sort((a, b) => b.value1 - a.value1).slice(0, 5);
      } else {
        return [];
      }
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
  // initMap2() {
  //     // 创建中国地图数据源
  //     const chinaSource = new VectorSource({
  //       url: '/china.topo.json', // 假设文件放在public目录下
  //       format: new TopoJSON(),
  //     });

  //     // 创建中国地图图层
  //     const chinaLayer = new VectorLayer({
  //       source: chinaSource,
  //       style: new Style({
  //         fill: new Fill({
  //           color: '#F7F6F1'
  //         }),
  //         stroke: new Stroke({
  //           color: '#E4CBB3',
  //           width: 2
  //         })
  //       })
  //     });

  //     // 创建标注点数据源
  //     const pointSource = new VectorSource();
  //     this.points.forEach(point => {
  //       const feature = new Feature({
  //         geometry: new Point(fromLonLat([point.lng, point.lat])),
  //         // name: point.name,
  //         value1: point.value1,
  //         value2: point.value2
  //       });
  //       pointSource.addFeature(feature);
  //     });

  //   // 创建标注点图层，使用本地图片
  //     const pointLayer = new VectorLayer({
  //       source: pointSource,
  //       style: feature => new Style({
  //         image: new Icon({
  //           src: '/images/hospital.svg', // 本地图片路径
  //           scale: 0.5, // 调整图片大小（根据实际图片尺寸调整）
  //           anchor: [0.5, 1], // 锚点设置为图片底部中心
  //         }),
  //         text: new Text({
  //           text: feature.get('name'),
  //           offsetY: -30, // 文字在图片上方，调整距离
  //           font: '12px sans-serif',
  //           fill: new Fill({ color: '#000' }),
  //           stroke: new Stroke({ color: '#fff', width: 2 })
  //         })
  //       })
  //     });
  //     // 初始化地图
  //     this.map = new Map({
  //       target: 'container',
  //       layers: [chinaLayer, pointLayer],
  //       view: new View({
  //         center: fromLonLat([116.3683244, 39.915085]), // 中国中心点
  //         zoom: 4
  //       })
  //     });
  //   },
    showPopup(item){
      //点击公司弹出公司详情，地图的中心点移动到该公司，地图放大到15级
      this.map.setZoomAndCenter(14, [item.lng, item.lat]);   
      let infoWindow = this.createInfoWindow(item);
      infoWindow.open(this.map, [item.lng, item.lat]); 
    },
    getStsData() {
      const url = "statistics/largescreen";
      this.$axios.get(url, null, false).then((res) => {
        console.log(res.data);
        if (res.data.code == 20000) {
          this.stsData = res.data.data;
          //汇总测评人数、测评次数
          this.sumValues = this.stsData.org.reduce(
            (accumulator, current) => {
              return {
                value1: accumulator.value1 + parseInt(current.value1, 10),
                value2: accumulator.value2 + parseInt(current.value2, 10),
              };
            },
            { value1: 0, value2: 0 }
          );

          this.drawGenderChart();
          this.drwaAgeChart();
          this.addMarker();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    //#region 地图相关
    initMap() {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        animateEnable: false,
        // mapStyle: 'amap://styles/fresh',
        mapStyle: 'amap://styles/macaron',
        // mapStyle: "amap://styles/darkblue",
        // // showLabel: false,
        //features: ['bg', 'road', 'building'],
        center: [108.96, 34.39], //初始地图的中心点坐标
        zoom: 5,
        scale:2
      });
      // this.getMapData();
    },
    //2.添加点标记
    addMarker() {
      const self = this;
      let arr = [];
      this.isShowInfo = false;
      this.map.remove(this.markers);
      this.markers = [];
      this.stsData.org.forEach((item) => {
        // let iconImg = hospitalIcon;
        const icon = new AMap.Icon({
          image: hospitalIcon, //require('@/assets/markers/zhongdian.svg'), // Icon的图像
          // imageOffset: new AMap.Pixel(0, -60), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 35), // 根据所设置的大小拉伸或压缩图片
        });

        const position = [item.lng, item.lat];

        let marker = new AMap.Marker({
          icon, //点标记图片路径
          position, //位置
          anchor: "bottom-center",
        });
        arr.push(
          Object.assign(item, {
            mapId: marker._amap_id,
          })
        );
        marker.setMap(self.map); 
  
        let infoWindow = new AMap.InfoWindow({
          isCustom: true,  //使用自定义窗体
          content: `<div  style="  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 12px;">${item.name}</div>`,
          offset: new AMap.Pixel(0, -30),
        });

        marker.on("mouseover", () => {
          infoWindow.open(self.map, marker.getPosition());
        });

        marker.on("mouseout", () => {
          infoWindow.close();
        });
 
        // marker.on("click", (e) => {
        //   let infoWindow = this.createInfoWindow(item);
        //   infoWindow.open(this.map, marker.getPosition());
        // });
        this.markers.push(marker);
      });
    },
    //创建弹窗
    createInfoWindow(data) {
      const eventx = require("@/assets/newImages/eventx.png");
      let sContent = `<div 
      class="content-window-card"
    > 
        <img 
          src="${eventx}" style="height: 20px;
           width: 45px;
           cursor: pointer;
           position: absolute;
           right: 10px;
           z-index:99;
           top: 8px;"
          
           onclick="closeInfoWindow()"
        />
      </div>
      <div class="info-middle">
        <div  style="margin: 12px 0px;position: relative;">
          <div class="popup-row"> 
        <div class="popup-row-label"> 医院名称：</div>
        <div class="popup-row-value">  ${data.name}</div> 
      </div>
      <div class="info-middle">
        <div  style="margin: 12px 0px;position: relative;">
          <div class="popup-row"> 
        <div class="popup-row-label"> 测评次数：</div>
        <div class="popup-row-value">  ${data.value1}</div> 
      </div>
       <div class="info-middle">
        <div  style="margin: 12px 0px;position: relative;">
          <div class="popup-row"> 
        <div class="popup-row-label"> 测评人数：</div>
        <div class="popup-row-value">  ${data.value2}</div> 
      </div>
      <div 
        style="margin: 0 auto;
              width: 40px;
              height: 20px;
              bottom:-18px;
              position: relative;
              overflow: hidden;">
              <div class="tdt-infowindow-tip"></div>
      </div>
    </div>`;
      let infoWindowData = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: sContent,
        // content: this.getContent(),
        anchor: "bottom-center",
        offset: new AMap.Pixel(0, -40),
      });
      window.showDetail = () => {
        this.showDetail(data);
      };
      window.closeInfoWindow = () => {
        console.log("close");
        this.map.clearInfoWindow();
      };
      return infoWindowData;
    },
    //#endregion

    //#region 业务统计

    drawGenderChart() {
      const genderData = this.stsData.gender;
      // 将数据转换为 ECharts 饼图所需的数据格式
      const data = [
        { value: genderData.gender1, name: "男性" },
        { value: genderData.gender2, name: "女性" },
        { value: genderData.gender3, name: "其他" },
      ];

      // 配置项
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          textStyle: {
            color: "#000", //tooltip文字颜色
          },
        },
        legend: {
          // orient: 'h',
          left: "center",
          data: ["男性", "女性", "其他"],
          textStyle: {
            // 图例文字样式
            color: "#fff", // 白色
          },
        },
        series: [
          {
            name: "性别",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"], // 饼图中心位置
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}: {c} ({d}%)",
              color: "#fff", // 标签文字颜色
            },
            // itemStyle: { // 图形样式
            //   borderColor: '#000', // 图形边框颜色
            //   borderWidth: 1 // 图形边框宽度
            // }
          },
        ],
        color: ["#1890FF", "#FFB6C1", "#2FC25B"],
        // backgroundColor: '#000' // 图表背景色
      };
      const myChart = echarts.init(document.getElementById("gender-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drwaAgeChart() {
      const ageData = this.stsData.age;
      const data = [
        { value: ageData["20岁以下"], name: "20岁以下" },
        { value: ageData["20-30岁"], name: "20-30岁" },
        { value: ageData["30-40岁"], name: "30-40岁" },
        { value: ageData["40-50岁"], name: "40-50岁" },
        { value: ageData["50岁以上"], name: "50岁以上" },
      ];
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          textStyle: {
            color: "#000",
          },
        },
        legend: {
          left: "center",
          data: ["20岁以下", "20-30岁", "30-40岁", "40-50岁", "50岁以上"],
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "年龄",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}: {c} ({d}%)",
              color: "#fff",
            },
          },
        ],
        color: ["#1890FF", "#FACC14", "#2FC25B", "#8543E0", "#13C2C2"], // 更多颜色
      };

      const myChart = echarts.init(document.getElementById("age-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    //#endregion
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // const today = this.$dayjs().format("YYYY-MM-DD");
    // // const yesterday = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
    // this.date.push(today, today);
    // this.searchParams.begin = today;
    // this.searchParams.end = today;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

    this.timer = setInterval(() => {
      const date = this.$dayjs(new Date());
      this.dateDay = date.format("HH:mm:ss");
      this.dateYear = date.format("YYYY-MM-DD");
      this.dateWeek = date.format(this.weekday[date.day()]);
    }, 1000);

    this.initMap();
    this.getStsData();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss">
@import url("./assets/index.css");

/* @import url(); 引入公共css类 */
.audit {
  * {
    font-family: FZZ;
  }

  // .el-radio-button__inner {
  //   border-radius: 4px 4px 4px 4px !important;
  //   // width: 88px !important;
  //   background: #024287;
  //   color: #7cc8ff;
  //   font-size: 14px;
  //   border: none !important;
  //   padding: 7px 6px;
  // }

  // .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  //   background: #18b0f9;
  //   font-size: 14px;
  //   border: none !important;
  //   color: #ffffff;
  // }

  // .el-radio-button {
  //   margin-right: 10px !important;
  // }

  // .is-checked {
  //   background: rgba(8, 174, 240, 0.6);
  //   /* 透明 */
  //   border: none;
  //   color: white;
  // }
}

.hidden {
  display: none;
}

.main-title {
  font-size: 16px;
  color: #47f0fb;
  font-weight: 700;
  text-align: center;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-top: 15px;
}
.tags {
  width: 100%;
  display: flex;
  margin-top: 10px;
}

.route-corridor {
  width: 200px;
  // stroke: red;
  // stroke-opacity: 0.4;
}

.look-history {
  text-align: right;
}

.list-title {
  cursor: default;
}
.videoBox-left {
  margin-right: 25px;
  width: 230px;
}
</style>

<style lang="scss" scoped>
.tooltip-content {
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
}
.number-box {
  color: rgb(71, 247, 253);
  font-weight: bold;
  font-size: 80px;
  font-family: "DIGGI";
}
#businese-content {
  width: 100%;
  height: 100%;
}

.main-list {
  cursor: pointer;
}

.table-no {
  width: 20%;
  flex: none;
}
.table-count {
  width: 20%;
  flex: none;
}
.category-menu-index {
  position: absolute;
  bottom: 100px;
  right: 400px;
  cursor: pointer;
  color: #fff;
  border-radius: 3px;
  width: 130px;
  height: 180px;
  display: flex;
  flex-direction: column;
  background: #000001;
  > div {
    padding: 12px 20px;
  }
}

.bottom-center {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 373px - 373px - 12px - 15px);

  display: flex;
  justify-content: space-around;
  align-items: center;
  // background: rgba(0, 51, 102, 0.8);
  border-radius: 10px;
  padding: 20px 0;
  // box-shadow: 0 0 10px rgba(0, 153, 255, 0.5);
}

.bottom-center-list {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
}

.bottom-center-list .company-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // width: 150px;
  // height: 100px;
  margin: 0 10px;
  // background: url(./assets/base.webp) no-repeat center center;
  background-size: 100% 100%;
  border-radius: 10px;
  // box-shadow: 0 0 10px rgba(0, 153, 255, 0.5);
  // color: #fff;
  color: #000;
  font-family: "DIGGI";
  text-align: center;
  padding: 10px;
  position: relative;
  cursor: pointer;
}
.bottom-center-img {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.company-rank {
  //width: 100%;
  font-size: 24px;
  font-weight: bold;
  // color: #30d6ff;
  color: #000;
  img{
    width: 35px; 
  }
}

.company-name {
  font-size: 18px;
  margin: 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-count {
  font-size: 20px; 
  margin-bottom: 40px;
  color: #000;
  // color: #47f7fd;
  font-weight: bold; 
  font-family: "DIGGI";
}

.top-center-inner {
  .top-center-title {
    color: #fff;
  }

  .top-center-value {
    color: rgb(71, 247, 253);
    font-weight: bold;
    font-size: 38px;
    width: 150px;
    height: 50px;
    line-height: 50px;
    padding-left: 16px;
    background: linear-gradient(to right, #20417f, #111944);
    border-radius: 5px;
    font-family: "DIGGI";
    .value-unit {
      font-size: 12px;
      color: #fff;
    }
  }
}

.top-center {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 100px;
  width: calc(100% - 770px);
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  height: 20px;
}

.weather-info {
  color: #fff;
}
.warning-table {
  margin-top: 5px;
  height: 116%;
}
.warning-box {
  width: calc(100% - 10px);
  height: auto;
  margin-bottom: 10px;
  // border: 1px solid #fff;
  color: #ffffff;
  display: flex;
  align-items: center;
  background-color: rgba(216, 19, 19, 0.3);
  border-radius: 10px;
  .warning-box-img {
    width: 150px !important;
    padding: 10px;
    text-align: center;
    img {
      margin-bottom: 10px;
    }
  }
  .warning-box-content {
    padding: 8px 8px 8px 0;
    .warning-companyname {
      color: #47f0fb;
      font-size: 16px;
      font-weight: bold;
    }
    .warning-text {
      color: #d7d7d7;
    }
  }
}
.search-input {
  // position: absolute;
  // top: 190px;
  // right: 400px;
  margin-top: 30px;
  z-index: 99;
  width: 200px;
  border-radius: 4px;
  /deep/.el-input__inner {
    background-color: rgba(0, 0, 1, 0.5) !important;
    border-color: #fff;
    // color: #47f7fd;
    color: #fff;
  }

  /deep/ .el-input__suffix {
    // color: #47f7fd;
    color: #fff;
  }
}

/deep/.popup-row {
  width: 350px;
  // width: 100%;
  padding: 4px 10px;
  font-size: 13px;
  display: flex;
  &::after {
    clear: both;
    content: "";
    display: block;
  }

  .popup-row-label {
    width: 90px;
    // display: inline-block;
    color: #7dc3f6;
    text-align: right;
    font-size: 14px;
  }

  .popup-row-value {
    flex: 1;
    // width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // display: block;
    // margin-left: 100px;
    color: #d7d7d7;
    font-size: 14px;
  }
}
/deep/ .amap-info {
  background: url("../../assets/newImages/infoWindow.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  // color: #024287;
}

/deep/ .tdt-container a.tdt-infowindow-close-button {
  color: transparent;
  background: url("../../assets/newImages/eventx.png") no-repeat;
  background-size: 100% 100%;
  width: 40px;
  height: 20px;
}
/deep/ .tdt-infowindow-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background: #094a92;
}
.el-input__inner {
  background-color: transparent;
}
/deep/ .el-date-editor .el-range-input {
  background-color: transparent;
  color: #fff;
}
/deep/ .el-range-separator {
  color: #fff;
}
/deep/ .el-date-editor .el-range__icon {
  color: #fff;
}
/deep/ .el-date-editor .el-range__close-icon {
  color: #fff;
}
</style>
